import type { ExcIceGsmV1InstrumentKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../../util/routing/entity-paths';

export const ICE_GSM_INSTRUMENT_BASE_PATH = getResolvedPath('/clearing/vendor/ice/instrument');

export const getIceGsmInstrumentPath: EntityPathBuilder<ExcIceGsmV1InstrumentKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return ICE_GSM_INSTRUMENT_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.instrumentId) {
        return undefined;
      }

      return getResolvedPath(`${ICE_GSM_INSTRUMENT_BASE_PATH}/$instrumentId`, context.keys);
    }
  }
};

export function getIceGsmInstrumentDetailPath(instrumentId: string | undefined) {
  if (!instrumentId) {
    return undefined;
  }

  return getIceGsmInstrumentPath({ kind: 'detail', keys: { instrumentId } });
}
